const boxBuilder = document.querySelector(".box-builder-banner");
const getStartedBtn = document.querySelectorAll(".getStartedBtn");

if (getStartedBtn.length > 0 && boxBuilder) {
    const boxBuilderHeight = boxBuilder.offsetHeight;

    getStartedBtn.forEach((btn) => {
        btn.addEventListener('click', () => {
           
            window.scrollTo({
                top: (boxBuilderHeight + 1),
                behavior: 'smooth'
            });
        });
    });
}
